import { ref } from 'vue'

const createProductsFilters = () => ({
    name: null,
    hasProductTypeComponents: null
})

const createPaginationMeta = () => ({
    count: 0,
    current: 1,
    next: null,
    previous: null
})

export function createProductsState() {
    return {
        // Products List
        products: ref([]),
        productsLoading: ref(false),
        productsFilters: ref(createProductsFilters()),
        productsMeta: ref(createPaginationMeta()),

        // Product Edit View
        currentProduct: ref(null),
        productProductionProperties: ref([]),
        productComponents: ref([]),
        productionProcesses: ref([]),
        productProperties: ref([]),
        allProductProperties: ref([]),

        // Factories
        createProductsFilters,
        createPaginationMeta
    }
}
